module.exports = __webpack_public_path__ + "img/co0.402eafa0.png";